var _path, _path2, _path3, _path4, _path5, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgAiDiscussion = function SvgAiDiscussion(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    fill: "none",
    viewBox: "0 0 38 23"
  }, props), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#ai-discussion_svg__a)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 12,
    height: 12.667,
    x: 16.333,
    y: 0.667,
    fill: "#A8FFF8",
    rx: 1,
    style: {
      mixBlendMode: "multiply"
    }
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 15.667,
    cy: 15,
    fill: "#CBFF88",
    rx: 6,
    ry: 4.333,
    style: {
      mixBlendMode: "multiply"
    }
  }), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#14454C",
    fillOpacity: 0.15,
    d: "M11 6h10v8h-4.667l-4 2.667v-3H11z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#14454C",
    fillRule: "evenodd",
    d: "M15 2.333c0-.184.15-.333.333-.333h11.334a.333.333 0 0 1 .333.333v9.334c0 .184-.15.333-.333.333H25v2.333a.333.333 0 0 1-.518.278L20.566 12h-5.233a.333.333 0 0 1-.333-.333zm.667.334v8.666h5q.1.001.185.056l3.481 2.322v-2.044a.333.333 0 0 1 .334-.334h1.666V2.667z",
    clipRule: "evenodd"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    stroke: "#14454C",
    strokeLinecap: "round",
    d: "M17.5 5.5h7M17.5 8.833h7"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    stroke: "#14454C",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M13.333 5.667h-2.666V14h2v2.667L16.333 14h5"
  }))), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fill: "#14D1C2",
    d: "m34.5 0 .99 2.51L38 3.5l-2.51.99L34.5 7l-.99-2.51L31 3.5l2.51-.99zM3.5 16l.99 2.51L7 19.5l-2.51.99L3.5 23l-.99-2.51L0 19.5l2.51-.99z"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "ai-discussion_svg__a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M9 0h20v20H9z"
  })))));
};
export { SvgAiDiscussion as ReactComponent };
export default __webpack_public_path__ + "fonts/ai-discussion-ec4f56c4798ec18fc318642d693470fe.svg";